<template>
  <div>
    <div v-wechat-title="$tm('index2024.condiment.title')" />
    <gc-skeleton :is-show="loading" />
    <gc-guide :down-show="guideShow" @showDwon="getGuideStatus" />
    <ShareInfo :share-info="shareData" />
    <Banner type="condiment" />
    <div class="index_content">
      <p class="index_rule">
        {{ $tm(`index2024.${pathInfo.type}.tip`) }}
      </p>
      <ul class="cdt_list mt20">
        <li
          v-for="(item, idx) in listData"
          :key="item.sort"
          class="list_item"
          @click="goPath('userview', item)"
        >
          <div class="item_left">
            <img :src="item.img1" alt="img" class="img">
            <div :class="'ranking ranking'+item.sort"><span class="ft_bm">TOP</span> <i class="ft_bm">{{ addZero(item.sort) }}</i></div>
            <div v-if="item?.data?.associated_brand" class="brand-tag">品牌</div>
          </div>
          <div class="item_right">
            <h3 class="font_bold text_over">{{ item.title }}</h3>
            <!-- <span><i class="ft_bm">{{ item.num2 }}</i>{{ $tm(`index2024.ingredientText1`) }}</span> -->
            <p><i class="ft_bm">{{ item.num1 }}</i> {{ $tm(`index2024.ingredientText2`) }}</p>
          </div>

          <!-- 关注 -->
          <div class="follow" v-if="item?.data?.associated_brand">
            <span v-if="item?.followed" class="followBtn rds48 followBtnEnd" @click.stop="follow(item, idx)">{{ $tm(`index2024.followingText`) }}</span>
            <span v-else class="followBtn rds48" @click.stop="follow(item, idx)">{{ $tm(`index2024.followText`) }}</span>
          </div>
        </li>
      </ul>
    </div>
    <SideMenu :type="pathInfo.type" />
    <Footer />
  </div>
</template>

<script>
import config from '@/config/config'
import { ajaxHttp } from '@/api/api'
import utils, { addZero } from '@/utils/utils'
import { superLink, checkloginCallback, platformType } from '@/utils/index'

import { Toast } from 'vant'
import Banner from '../components/banner'
import Footer from '../components/footer'
import SideMenu from '../components/sideMenu'
import ShareInfo from '@/components/shareInfo'
import GcGuide from '@/components/gc-guide'
import GcSkeleton from '@/components/gc-skeleton'
export default {
  name: 'Condiment',
  components: {
    Banner,
    Footer,
    SideMenu,
    ShareInfo,
    GcGuide,
    GcSkeleton
  },
  data() {
    return {
      loading: true, // 接口loading效果
      guideShow: false, // 微信点击的引导提示框
      pathInfo: {}, // 页面路径传参
      listData: [], // 列表数据
      shareData: { // 分享数据
        share_title: '',
        share_des: '',
        share_link: '',
        share_img: ''
      }
    }
  },
  created() {
    const { query } = this.$route
    this.pathInfo = query
    this.getListData()

    // 分享信息
    this.shareData = {
      share_title: this.$tm(`index2024.${query.type}`).share_title,
      share_desc: this.$tm(`index2024.${query.type}`).share_des,
      share_link: location.href,
      share_img: 'https://static.mingchu.co/webapp/index2024/share/condiment.png'
    }

    if (utils.getQueryVariable('token')) { 
      this.shareData.share_title = '20种调味料共同塑造了2024 的千秋味道。' 
      this.shareData.share_img = 'https://static.mingchu.co/webapp/index2024/minishare/condiment.png'
    }
  },
  mounted() {
    window.scroll(0, 0)
    window.mitt.on('guideShow', ($info) => { // 监听微信内点击弹起引导提示框
      this.guideShow = $info
    })
    /* eslint-disable */
    sensors.track('MCINDEX2024_visit', {
      MCINDEX_title: 'condiment',
      from: '2024指数_最受欢迎的调味页面访问量',
      PlatformType: platformType()
    })
  },
  destroyed() {
    window.mitt.off('guideShow') // 销毁
  },
  methods: {
    addZero,
    getListData() { // 获取列表数据
      const self = this
      ajaxHttp.$get('/api/ranking2024/detail', { leader_type: self.pathInfo.type }).then(res => {
        if (res.code === 1) {
          this.listData = res.data?.leaders ?? []
        }
        this.$nextTick(() => {
          self.loading = false
        })
      })
    },
    async follow(item, idx) {
      const self = this
      // 添加埋点
      sensors.track('MCINDEX2024_follow', {
        MCINDEX_title: this.pathInfo.type,
        from: '2024指数_最受欢迎的调味页面品牌关注',
        PlatformType: platformType(),
      })
      // 检查app是否登录，然后执行回调函数
      checkloginCallback(async function() { // 统一的接口请求方法
          const res = await ajaxHttp.followAddTo2024({ follow_user_id: item?.data?.associated_brand })
          if (res.code === 1) { 
            item.followed = !!Number(res.data.follow_status)
          }
          Toast(res.message)
        }, this // 要传进去个this
      )
    },
    goPath($des, item) {
      if (!item.data?.associated_brand) {
        return false
      }
      sensors.track('MCINDEX2024_card_click', {
        MCINDEX_title: this.pathInfo.type,
        from: '2024指数_最受欢迎的食材页面相关作品点击',
        card_name: item.title,
        PlatformType: platformType(),
      })

      const data = `{
        "des": "${$des}", 
        "skuid": "${item.data.associated_brand}",
        "link": "${config.webapplink}/${$des}?id=${item.data.associated_brand}"
      }`
      return superLink(data)
    },
    getGuideStatus(val) { // 获取子组件的返回
      this.guideShow = false
    }
  }
}
</script>
